import tw from 'tailwind-styled-components'

const dialogPanel = `
w-full 
max-w-[812px] 
transform 
overflow-hidden 
rounded-2xl 
bg-white 
p-8 
text-left 
align-middle 
shadow-xl 
transition-all
`

export const ButtonAction = tw.button`
inline-flex
items-center
justify-center
h-[38px]
py-2
px-4
border
border-blueTheme
rounded-lg
text-sm
active:scale-95
transition-colors
cursor-pointer
hover:brightness-90
`
export const Body=tw.div``
export const NotificationDoneBy = tw.div`
flex
flex-col
items-center
justify-center
p-4
mt-4
gap-1
`
export const DataBox = tw.div`
mt-9
border
border-solid 
border-gray-300
p-4
`
export const ButtonsContainer = tw.div`
flex gap-4 mt-8
items-center
justify-center

`
const dialogTitle = `
text-lg 
font-medium 
leading-6 
text-gray-900
flex
justify-between
items-center
`

export { dialogPanel, dialogTitle }
